import {Injectable} from '@angular/core';
import {Action, Selector, State, StateContext} from '@ngxs/store';
import {JsonApiResponse} from '@tisa-group/cdk';
import {OttEventService} from '@tisa-group/core/api/umpire';
import {UmpireOttEvent} from '@tisa-group/models';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {FetchFeaturedEvents} from './featured-events.actions';

export type FeaturedEventsStateModel = JsonApiResponse<UmpireOttEvent[]>;

@State<FeaturedEventsStateModel>({
  name: 'FeaturedEvents',
})
@Injectable()
export class FeaturedEventsState {
  @Action(FetchFeaturedEvents)
  LoadFeaturedEvents(
    ctx: StateContext<FeaturedEventsStateModel>,
    action: FetchFeaturedEvents,
  ): Observable<JsonApiResponse<UmpireOttEvent[]>> | JsonApiResponse<UmpireOttEvent[]> {
    const state = ctx.getState();

    if (state?.data) {
      return state;
    }

    return this.eventService
      .list({
        include: ['image_horizontal', 'format'].join(','),
        filter: {is_featured: {rule: 'true', value: true}},
        sort: ['custom_events_sort'],
        page: {
          size: 30,
          number: 0,
        },
      })
      .pipe(tap(res => ctx.setState(res)));
  }

  @Selector()
  static featuredEvents(state: FeaturedEventsStateModel): FeaturedEventsStateModel {
    return state;
  }

  constructor(readonly eventService: OttEventService) {}
}
